/* eslint-disable indent */
// /* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Row, Col, Input, Button, Form, message, Spin } from "antd";
import {
  checkAlphabets,
  checkNumbervalue,
  checkSpace,
  checkSpecialCharacter,
} from "../../../utils";

import CPDetails from "../CPDetails";

import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { customerOnboardingAPI } from "../../../api/LeadApi/index";

export const BasicDetails = ({
  handleStepsChange = () => {},
  patchClient,
  getData,
  setCpPinCodeData,
}) => {
  const customerId = localStorage.getItem("customerId");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [clickedButton, setClickedButton] = useState(null);
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    setLoading(true);

    if (getData) {
      const address = getData?.addresses?.find(
        (e) => e?.type?.toLowerCase() === "default"
      );
      const initialFormValues = {
        orgName: getData?.orgName || null,
        number: getData?.contactNumbers?.[0]?.number || null,
        email: getData?.emails?.[0]?.email || null,
        cpType: "BOOKING",
        street: address?.street,
        area: address?.area,
        pincode: address?.pincode,
        dropRadius: getData?.metadata?.find((e) => e?.key === "DROP_RADIUS")
          ?.value,
        nameOfOwner: getData?.businessDetail?.nameOfOwner,
        businessFlag: getData?.businessDetail?.businessFlag,
      };
      form.setFieldsValue(initialFormValues);
      setInitialValues(initialFormValues);
      setLoading(false);
    }
    setLoading(false);
  }, [getData]);

  const getChangedValues = (initial, current) => {
    return Object.keys(current).reduce((acc, key) => {
      if (initial[key] !== current[key]) {
        acc[key] = current[key];
      }
      return acc;
    }, {});
  };

  const createBasicDetails = async (val) => {
    setLoading(true);
    const checkBtn = clickedButton === "saveAndContinueButton";
    const changedValues = getChangedValues(initialValues, val);

    if (Object.keys(changedValues).length === 0) {
      message.info("No changes detected.");
      setLoading(false);
      return;
    }
    setCpPinCodeData(val?.pincode);
    // let payload = {
    //   customerType: "CP",
    //   orgName: val?.orgName,
    //   source: "website",

    //   pincode: val?.pincode,
    //   emails: [{ email: val?.email, type: "personal" }],
    //   contactNumbers: [{ number: val?.number, type: "default" }],
    //   addresses: [
    //     {
    //       street: val?.street,
    //       area: val?.area,
    //       postalCode: val?.pincode,
    //       type: "default",
    //     },
    //   ],
    //   remark: val?.remark,
    //   businessDetail: {
    //     nameOfOwner: val?.nameOfOwner,
    //     //natureOfBusiness: "default",
    //   },
    //   metadata: [
    //     {
    //       key: "CP_TYPE",
    //       value: "BOOKING",
    //     },
    //     {
    //       key: "DROP_RADIUS",
    //       value: val?.dropRadius,
    //     },
    //   ],
    // };

    const payload = {
      customerType: "CP",
      ...changedValues,
      businessDetail: {
        businessFlag: val?.businessFlag,
      },
      source: "website",
      emails: changedValues?.email
        ? [{ email: val?.email, type: "personal" }]
        : undefined,
      contactNumbers: changedValues?.number
        ? [{ number: val?.number, type: "default" }]
        : undefined,
      addresses:
        changedValues?.pincode || changedValues?.street || changedValues?.area
          ? [
              {
                street: val?.street,
                area: val?.area,
                pincode: val?.pincode,
                type: "default",
              },
            ]
          : undefined,
      metadata: [
        { key: "CP_TYPE", value: "BOOKING" },
        ...(changedValues?.dropRadius
          ? [{ key: "DROP_RADIUS", value: val?.dropRadius }]
          : []),
      ],
    };

    if (customerId === null) {
      let response = await customerOnboardingAPI.createLead(payload);

      if (response?.status) {
        setLoading(false);
        if (checkBtn) {
          handleStepsChange(1);
        }
        message.success(response?.message || "CP added successfully");
        localStorage.setItem(
          "customerId",
          response?.response?.data?.data?.customerId
        );
      } else {
        message.error(response?.response?.data?.message || "Network error");
        setLoading(false);
      }
    } else {
      setLoading(false);
      patchClient(payload, checkBtn);
    }
  };

  const cancelReset = () => {
    localStorage.removeItem("customerId");
    window.history.back();
  };

  return (
    <Spin
      spinning={loading}
      size="large"
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div>
        <Form
          id="myForm"
          className="global-form profile-container-form pl-4 pr-4 p-2"
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={createBasicDetails}
          initialValues={{ cpType: "Booking" }}
        >
          <Row gutter={40} className="global-form-row">
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="nameOfOwner"
                label="Name of owner"
                onKeyPress={(event) => {
                  if (checkAlphabets(event)) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    message: "Please enter owner name",
                    required: true,
                  },
                ]}
              >
                <Input
                  placeholder="Enter owner name"
                  maxLength={40}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                  // disabled={getData ? true : false}
                />
              </Form.Item>
            </Col>
            <Col span={12} />
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="number"
                label="Phone number"
                rules={[
                  {
                    required: true,
                    message: "Please enter mobile number",
                  },
                  {
                    pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                    message: "Invalid mobile number",
                  },
                ]}
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpecialCharacter(event) ||
                    checkSpace(event)
                  ) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Enter phone number"
                  maxLength={10}
                  disabled={getData?.status?.toLowerCase() === "approved"}
                  // onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="email"
                label="Email-ID"
                type="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter E-mail",
                  },
                  {
                    type: "email",
                    message: "The input is not valid E-mail",
                    validateTrigger: "onSubmit",
                  },
                ]}
              >
                <Input
                  placeholder="Enter E-mail"
                  disabled={getData?.status?.toLowerCase() === "approved"}
                />
              </Form.Item>
            </Col>

            <CPDetails getData={getData} />
          </Row>
          <hr className="divider" />
          <div className="flex-end mt-1">
            <Button
              className="cancel-btn ml-1 w-15"
              id="save"
              onClick={cancelReset}
            >
              BACK
            </Button>
            {getData?.status?.toLowerCase() !== "approved" ? (
              <>
                <Button htmlType="submit" className="cancel-btn ml-1 w-15">
                  SAVE
                </Button>
                <Button
                  htmlType="submit"
                  id="saveNContinue"
                  onClick={() => setClickedButton("saveAndContinueButton")}
                  className="save-btn  ml-1"
                >
                  SAVE & CONTINUE
                </Button>
              </>
            ) : (
              <Button
                id="saveNContinue"
                onClick={() => handleStepsChange(1)}
                className="save-btn  ml-1"
              >
                NEXT
              </Button>
            )}
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BasicDetails;
